// @flow
import React from "react";
import { type CardItemResultDTO } from "data/types";
import Header from "components/Header";
import SearchInput from "@hs/search-input";

type Props = {
    /** current ArchiveTarget */
    archiveTarget: CardItemResultDTO,
    /** callback when user clicks Cancel */
    onCancel: () => void,
    /** callback when user types anything into filter text
     * @param {string} filterText filterText to apply
     */
    onFilterTextChange?: (filterText: string) => void,
    /** current filterText value */
    filterText?: string,
};

/**
 * renders an ArchiveTarget panel header
 */
const ArchiveTargetHeader = ({
    archiveTarget,
    onCancel,
    onFilterTextChange,
    filterText,
}: Props) => (
    <Header
        image={archiveTarget.image}
        // title={archiveTarget.name}
        description={archiveTarget.description}
        isFav={archiveTarget.itemUri === "at-fav"}
        isRecent={archiveTarget.itemUri === "at-rec"}
        onCancel={onCancel}
        centerComponent={
            <SearchInput
                borderless
                key="searchTargets"
                placeholder={archiveTarget.name}
                onChange={onFilterTextChange}
                value={filterText}
            />
        }
    />
);

ArchiveTargetHeader.displayName = "ArchiveTargetHeader";
export default ArchiveTargetHeader;
